module.exports = __webpack_public_path__ + "static/media/favicon.42a7b628.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/favicon.ico
// module id = 645
// module chunks = 0